import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Grid, TextField, Typography } from "@mui/material";

import { getsRol } from "../../services/seguridadService";
import DataGridBase from "../../components/common/DataGridBase";
import { useMantenimiento } from "../../hooks/useMantenimiento";

// Listado de roles. Cada rol tiene sus accesos, que se asignan desde la
// pantalla de edicion.
const Role = () => {
    const { isReadOnly } = useMantenimiento("rol");
    const navigate = useNavigate();

    const [filters, setFilters] = useState({ nombre: "" });
    const [results, setResults] = useState([]);
    const [cargando, setCargando] = useState(true);

    const fetchResults = useCallback(async () => {
        setCargando(true);

        const data = await getsRol().catch((err) => { console.log("Err: ", err) });

        // El grid pide un id unico por fila.
        setResults((data || []).map((row) => ({ ...row, id: row.id })));
        setCargando(false);
    }, [])

    useEffect(() => {
        fetchResults();
    }, [fetchResults])

    const columns = [
        {
            field: 'id',
            headerName: 'ID',
            width: 70,
            sortable: true,
            headerAlign: 'center',
            align: 'center',
            ocultarConAuditoria: false,
            renderCell: (cellValues) => (
                <Box
                    sx={{ cursor: 'pointer', textDecoration: 'underline', color: 'primary.main', fontWeight: 500 }}
                    onClick={() => navigate("/security/role/edit/" + cellValues.row.id)}
                >
                    {cellValues.row.id}
                </Box>
            )
        },
        {
            field: 'nombre',
            headerName: 'Rol',
            width: 220,
            sortable: true,
            headerAlign: 'left',
            renderCell: (cellValues) => (
                <Box
                    sx={{ cursor: 'pointer', textDecoration: 'underline', color: 'primary.main', fontWeight: 500 }}
                    onClick={() => navigate("/security/role/edit/" + cellValues.row.id)}
                >
                    {cellValues.row.nombre}
                </Box>
            )
        },
        { field: 'descripcion', headerName: 'Descripcion', width: 260, sortable: false, headerAlign: 'left' },
        { field: 'estado', headerName: 'Estado', width: 90, sortable: false, headerAlign: 'center', align: 'center'
            , valueGetter: (value, row) => row.idEstado == 2 ? "Activo" : "Inactivo"
        },
    ];

    const filtrados = results.filter((row) => {
        if (!filters.nombre) return true;

        const busqueda = filters.nombre.toLowerCase();
        return (row.nombre || "").toLowerCase().includes(busqueda)
            || (row.descripcion || "").toLowerCase().includes(busqueda);
    });

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Roles
                    </Typography>
                </Grid>
                <Grid container spacing={1} alignItems={"center"} padding={"12px 0px 0px 0px"}>
                    <Grid item xs={8} sm={4}>
                        <TextField
                            name="nombre"
                            label="Rol o descripcion"
                            value={filters.nombre}
                            fullWidth
                            onChange={(event) => setFilters({ ...filters, nombre: event.target.value })}
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase
                                rows={filtrados}
                                columns={columns}
                                loading={cargando}
                                disabled={isReadOnly}
                                onRowDoubleClick={(params) => navigate("/security/role/edit/" + params.row.id)}
                                toolbarButtons={[
                                    {
                                        text: "Nuevo",
                                        disabled: isReadOnly,
                                        onClick: () => navigate("/security/role/edit/0")
                                    }
                                ]}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}

export default Role;
